import React from "react";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import "../../styles/desktop/lightGroup.css";

import {sendCommandFlex35} from "../../API/basic/AcionamentoFlex35";
import {sendCommandFlex8} from "../../API/basic/AcionamentoFlex8";

export class LightGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupId: props.groupId,
      className: props.className,
      descricao: props.descricao,
      imageUrl: props.imageUrl,
      onCommand: props.onCommand,
      offCommand: props.offCommand,
      x: props.x,
      y: props.y,
      width: props.width,
      height: props.height,
      imageState: this.convertToBoolean(props.imageState),
      lights: [],
      circleNumber: props.circleNumber || "", // Número a ser exibido
      isLedStrip: props.isLedStrip || false, // Indica se é uma fita LED
      ledPath: props.ledPath || "", // Caminho SVG para fitas LED
      ledColor: props.ledColor || "#ff9900", // Cor da fita LED
      ledMode: props.ledMode || "static", // Modo de animação: static, pulse, flow, gradual
      ledStrokeWidth: props.ledStrokeWidth || 1.5, // Espessura da fita LED (padrão: 1.5)
    };
  }

  convertToBoolean(value) {
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return value;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imageState !== this.props.imageState) {
      this.setState({ imageState: this.convertToBoolean(this.props.imageState) });
      this.updateLightsState(this.convertToBoolean(this.props.imageState));
    }
    
    if (prevProps.circleNumber !== this.props.circleNumber) {
      this.setState({ circleNumber: this.props.circleNumber });
    }
    
    if (prevProps.ledStrokeWidth !== this.props.ledStrokeWidth) {
      this.setState({ ledStrokeWidth: this.props.ledStrokeWidth });
    }
  }

  updateLightsState = (newImageState) => {
    this.setState((prevState) => ({
      lights: prevState.lights.map((light) => ({
        ...light,
        imageState: newImageState,
      })),
    }));
  }

  toggleLights = () => {
    const newImageState = !this.state.imageState;
    this.setState({ imageState: newImageState });
    const action = newImageState ? this.state.onCommand : this.state.offCommand;
    this.sendCommand(this.state.descricao, action);

    // Atualiza o estado de todas as luzes no grupo
    this.updateLightsState(newImageState);
    this.props.onToggleLightGroup(this.state.groupId, newImageState);
  };

  sendCommand(descricao, action) {
    if (action.length === 4) {
      sendCommandFlex35(descricao, action);
    } else {
      sendCommandFlex8(descricao, action);
    }
  }

  renderPointLight() {
    const { imageState, descricao, circleNumber, groupId } = this.state;
    
    return (
      <div className="light-container">
        <img
          id={groupId}
          className="imageLuz"
          src={imageState ? Ligado : Desligado}
          alt={descricao}
        />
        
        {circleNumber && (
          <div className="circle-overlay">
            <div className={`light-number ${imageState ? 'light-number-on' : 'light-number-off'}`}>
              {circleNumber}
            </div>
          </div>
        )}
        
        {this.state.lights.map((light, index) => (
          <div key={index} className="Light" onClick={this.toggleLights}>
            <img
              src={light.imageState ? Ligado : Desligado}
              alt={light.descricao}
              className="imageLuz"
            />
          </div>
        ))}
      </div>
    );
  }

  renderLEDStrip() {
    const { imageState, ledPath, ledColor, ledMode, ledStrokeWidth } = this.state;
    
    // Determinar classes com base no estado e modo
    const ledClasses = [
      "led-strip",
      imageState ? "led-strip-on" : "led-strip-off",
      imageState && ledMode === "pulse" ? "led-pulse" : "",
      imageState && ledMode === "flow" ? "led-flow" : "",
      imageState && ledMode === "gradual" ? "led-gradual" : ""
    ].filter(Boolean).join(" ");
    
    // Estilo condicional baseado no estado
    const ledStyle = {
      "--led-color": ledColor,
    };
    
    // Os eventos de clique irão diretamente no path do SVG, não em um contêiner
    return (
      <svg 
        className="led-strip-container" 
        style={ledStyle}
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
        pointerEvents="none" // Importante: desativa eventos no SVG em geral
      >
        {/* Caminho visível da fita LED */}
        <path 
          d={ledPath} 
          stroke={imageState ? ledColor : "#333"} 
          strokeWidth={ledStrokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={ledClasses}
          vectorEffect="non-scaling-stroke"
          pointerEvents="none" // Desativa eventos no caminho visível
        />
        {/* Caminho invisível mais largo APENAS para cliques */}
        <path 
          d={ledPath} 
          stroke="rgba(0,0,0,0)" 
          strokeWidth="12" 
          fill="none"
          className="led-strip-hitbox"
          vectorEffect="non-scaling-stroke"
          pointerEvents="stroke" // Apenas o caminho de contorno recebe eventos!
          onClick={this.toggleLights}
          style={{ cursor: 'pointer' }}
        />
      </svg>
    );
  }

  render() {
    const { x, y, width, height, className, isLedStrip } = this.state;
    const { groupId } = this.props;
    const style = {
      left: `${x}%`,
      top: `${y}%`,
      width: `${width}%`,
      height: `${height}%`,
      position: "absolute",
      pointerEvents: isLedStrip ? "none" : "auto", // Desativa eventos no container para LED strips
    };
  
    return (
      <div 
        id={`group-${groupId}`} 
        className={`LightGroup ${className} ${isLedStrip ? 'led-strip-group' : 'point-light-group'}`} 
        style={style} 
        onClick={isLedStrip ? null : this.toggleLights} // Apenas pontos de luz usam este handler
      >
        {isLedStrip ? this.renderLEDStrip() : this.renderPointLight()}
      </div>
    );
  }
}